import { ReactNode } from 'react';
import { BULK_POPOVER_ATTR, TruncationPopoverContent } from '@ardoq/popovers';

export const resolveTruncationPopover = (
  element: HTMLElement | SVGElement
): ReactNode | null => {
  const isTruncated =
    element.scrollWidth > element.clientWidth ||
    element.scrollHeight > element.clientHeight;
  if (!element.textContent || !isTruncated) {
    return null;
  }
  return (
    <TruncationPopoverContent>{element.textContent}</TruncationPopoverContent>
  );
};

/** Spread on any clipping label span to opt into the matrix truncation popover. */
export const truncationPopoverAttrs = {
  [BULK_POPOVER_ATTR]: 'true',
};
